/**
 * Hybrid Grid component.
 * Automatically chooses between the Tailwind implementation (preferred) and the
 * styled-components implementation. Grid never exposed styled-system props on its
 * public API, so the realistic styled-components trigger is a styled(Grid)
 * extension — routing on needsStyledComponents preserves that backward
 * compatibility (and any accidental styled-system prop spread).
 */

import React from "react";
import { needsStyledComponents } from "@sproutsocial/seeds-react-system-props";
import Container from "./styles"; // Styled-components version
import { GridTailwind } from "./GridTailwind"; // Tailwind version
import { toResponsiveGapObject } from "./utils";
import type { GridProps } from "./GridTypes";

const GridHybrid: React.FC<GridProps> = (props) => {
  const {
    columns = 1,
    gap = 400,
    rowGap,
    columnGap,
    children,
    className,
  } = props;

  if (needsStyledComponents(props)) {
    return (
      <Container
        display="grid"
        rowGap={toResponsiveGapObject(rowGap ?? gap)}
        columnGap={toResponsiveGapObject(columnGap ?? gap)}
        $columns={columns}
        className={className}
      >
        {children}
      </Container>
    );
  }

  // Use Tailwind version (preferred - better performance)
  return <GridTailwind {...props} />;
};

GridHybrid.displayName = "Grid";
export default GridHybrid;
